import { render, staticRenderFns } from "./PassbookStatement.vue?vue&type=template&id=34aa7cee&scoped=true&"
import script from "./PassbookStatement.vue?vue&type=script&lang=js&"
export * from "./PassbookStatement.vue?vue&type=script&lang=js&"
import style0 from "./PassbookStatement.vue?vue&type=style&index=0&id=34aa7cee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa7cee",
  null
  
)

export default component.exports